import React from "react";

export default function Backdrop(props){
    return(
        <div className={props.className}>
            Backdrop
        </div>
    )
}